import { Checkbox, Col, Row } from "antd";
import React from "react";

const TableHeader: React.FC<ITableHeader> = ({
  headOptions,
  handleCheckBox,
}) => {
  return (
    <>
      <Row gutter={[16, 16]} className="table-header-container-row">
        {headOptions.map((item) => {
          return (
            <Col
              className={`table-head-label ${item.extraClass}`}
              span={item.span}
              key={item.text}
            >
              {handleCheckBox && item.checkboxId && item.isCheckBox === true ? (
                <Checkbox
                  onChange={(e) =>
                    item.checkboxId &&
                    handleCheckBox(e.target.checked, item.checkboxId)
                  }
                />
              ) : (
                item.text
              )}
            </Col>
          );
        })}
      </Row>
    </>
  );
};
export default TableHeader;
